<template>
  <div class="panel-header-etkilesim">
    <div id="panel-kullanici-navbar">
      <v-btn tile text rounded class="pl-1">
        <v-avatar>
          <v-icon size="28">mdi-bell</v-icon>
        </v-avatar>
        <span class="text-caption" style="letter-spacing: 1px !important;">Bildirimler</span>
      </v-btn>
      <v-tooltip bottom color="primary">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" tile text>
            <v-avatar>
              <v-icon size="30" dark>mdi-account-circle</v-icon>
            </v-avatar>
            <span class="text-caption">{{ authUser.name }}</span>
          </v-btn>
        </template>
        <span>{{$t('PANEL.HEADER.AUTH_USER_INFO_TEXT')}}</span>
      </v-tooltip>
    </div>
    <v-menu v-if="panelSettings.child" open-on-click bottom left offset-y :value.sync="systemSettingsMenu" @input="systemSettingsMenu = $event">
      <template v-slot:activator="{ on }">
        <v-tooltip :menu-listen="on" bottom color="primary" :disabled="systemSettingsMenu">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon medium @click="systemSettingsMenu = !systemSettingsMenu">
              <v-icon size="1.2rem">mdi-cog</v-icon>
            </v-btn>
          </template>
          <span>{{$t('PANEL.HEADER.SYSTEM_AREA_TEXT')}}</span>
        </v-tooltip>
      </template>
      <v-list>
        <template v-for="(item, index) in panelSettings.child">
          <span v-if="['widgets', 'developer'].includes(index) && !isDeveloper"></span>
          <v-list-item :key="index" v-else v-ripple class="panel-nav-items-container">
            <v-hover v-slot:default="{ hover }">
              <v-list-item-title class="panel-nav-items" :class="hover ? 'nav-is-hover' : ''">
                <RouterLink class="panel-nav-a-items text-body-2" :to="`${panelSettings.link}/${item.link}`">
                  <v-icon class="mr-2">{{ item.icon }}</v-icon>
                  {{ item.name }}
                </RouterLink>
              </v-list-item-title>
            </v-hover>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
    <v-tooltip bottom color="primary">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-on="on" v-bind="attrs" icon medium @click="logout">
          <v-icon size="1.5rem" :style="{ top: '1px' }">mdi-power</v-icon>
        </v-btn>
      </template>
      <span>{{$t('PANEL.HEADER.LOGOUT')}}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "HeaderManagement",
  data() {
    return {
      authUser: {
        /**
         * Giriş yapmış kullanıcının datasını
         * $store üzerinden al
         */
        name: this.$store.getters["User/UserLogin/getAuthUser"].name,
        nickName: this.$store.getters["User/UserLogin/getAuthUser"].nickname,
        email: this.$store.getters["User/UserLogin/getAuthUser"].email
      },
      systemSettingsMenu: false
    };
  },
  computed: {
    ...mapState({
      loading: state => state.loadingStatus,
      panelSettings: state => state.panelSettings
    }),
    ...mapGetters({
      getAuthUser: "User/UserLogin/getAuthUser"
    }),
    isDeveloper() {
      return this.getAuthUser.developer;
    }
  },
  methods: {
    logout: function() {
      this.$store.dispatch("User/UserLogin/authLogout").then(() => {
        window.location.replace("login");
      });
    }
  }
};
</script>

<style></style>
